module.exports = __webpack_public_path__ + "static/img/robot-avatar2.88cbb79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/robot-avatar2.png
// module id = ectR
// module chunks = 1